module.exports = __webpack_public_path__ + "img/inverter.df01b394.svg";